export default "__VITE_ASSET__dAAo1vDD__"